import contextLoadable from '@signal/core/contextFetch/Loadable'
import { LicenseInformationDataContext } from '@signal/core/licenseInformation'
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'
import Component from './Component'
import Loader from './Loader'
import Skeleton from './Skeleton'
import { LicenseInformationPropsType } from './types'

// this is a context loadable, which renders the Component once all the fetch contexts are loaded, and renders the
// skeleton until they are loaded.
export default withCommonSnapshotsOnly(
  contextLoadable<LicenseInformationPropsType>({
    fetchContexts: [LicenseInformationDataContext],
    Component,
    Loader,
    Skeleton
  })
)
